module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "statistics d-flex justify-content-between"
  }, [_c('li', {
    staticClass: "panel stats narrow mr-2"
  }, [_c('h6', [_vm._v("Check-ins")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('h1', {
    staticClass: "mr-2"
  }, [_vm._v(_vm._s(_vm.reservation.paxCheckedIn) + "/" + _vm._s(_vm.paxTotal))]), _vm._v(" "), _c('ul', {
    staticClass: "ml-5"
  }, [_c('li', {
    staticClass: "color-6"
  }, [_vm._v(_vm._s(_vm.missing) + " missing")]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.reservation.paxNoShow) + " no show")])])])]), _vm._v(" "), _c('li', {
    staticClass: "panel stats narrow flex-all mr-2"
  }, [_c('h6', [_vm._v("Extras")]), _vm._v(" "), (_vm.extras.length > 0) ? _c('ul', _vm._l((_vm.extras), function(extra) {
    return _c('li', [(extra.item.quantity) ? _c('div', [_vm._v("\n                    " + _vm._s(extra.item.quantity) + " " + _vm._s(extra.item.name) + "\n                ")]) : _vm._e()])
  }), 0) : _c('div', [_vm._v("-")])]), _vm._v(" "), _c('li', {
    staticClass: "panel stats mixed narrow d-flex"
  }, [_c('div', {
    staticClass: "separator mr-3"
  }, [_c('h6', [_vm._v("Total")]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.paid.toFixed(2)) + "€")])]), _vm._v(" "), _c('div', [_c('h6', [_vm._v("In due")]), _vm._v(" "), _c('h1', [(_vm.due > 0) ? _c('span', {
    staticClass: "color-6"
  }, [_vm._v("\n                    " + _vm._s(_vm.due.toFixed(2)) + "€\n                ")]) : _c('span', [_vm._v("-")])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-70f318a0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70f318a0"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/view/ViewStatistics.vue
// module id = 2013
// module chunks = 0